// Цвета текстиля
export default {
  state: {
    // id - УНИК. идентификатор, label - название, hex - код цвета HTML hex
    'white': {
      id: 'white',
      label: 'Белый',
      hex: '#f5f5f5',
    },
    'turquoise': {
      id: 'turquoise',
      label: 'Бирюзовый',
      hex: '#336699',
    },
    'burgundy': {
      id: 'burgundy',
      label: 'Бордовый',
      hex: '#9B2D30',
    },
    'cyan': {
      id: 'cyan',
      label: 'Голубой',
      hex: '#0099FF',
    },
    'blue-metallic': {
      id: 'blue-metallic',
      label: 'Голубой металлик',
      hex: '#6699CC',
    },
    'yellow': {
      id: 'yellow',
      label: 'Желтый',
      hex: '#FFD101',
    },
    'green': {
      id: 'green',
      label: 'Зеленый',
      hex: '#008000',
    },
    'gold': {
      id: 'gold',
      label: 'Золото',
      hex: '#808000',
    },
    'brown': {
      id: 'brown',
      label: 'Коричневый',
      hex: '#663333',
    },
    'red': {
      id: 'red',
      label: 'Красный',
      hex: '#DA1F26',
    },
    'orange': {
      id: 'orange',
      label: 'Оранжевый',
      hex: '#FFA500',
    },
    'pink': {
      id: 'pink',
      label: 'Розовый',
      hex: '#FF69B4',
    },
    'lettuce': {
      id: 'lettuce',
      label: 'Салатовый',
      hex: '#66CC00',
    },
    'light-beige': {
      id: 'light-beige',
      label: 'Светло-бежевый',
      hex: '#FFFEB6',
    },
    'silver': {
      id: 'silver',
      label: 'Серебро',
      hex: '#C0C0C0',
    },
    'blue': {
      id: 'blue',
      label: 'Синий',
      hex: '#0000FF',
    },
    'dark-green': {
      id: 'dark-green',
      label: 'Темно-зеленый',
      hex: '#013220',
    },
    'dark-blue': {
      id: 'dark-blue',
      label: 'Темно-синий',
      hex: '#000066',
    },
    'purple': {
      id: 'purple',
      label: 'Фиолетовый',
      hex: '#9933CC',
    },
    'black': {
      id: 'black',
      label: 'Черный',
      hex: '#000000',
    },
  }
}